// The custom field a filter row points at — by id; a default filter's key never resolves to a same-named custom field (ENG-4321).
type CustomFilterLike = {
  id?: unknown;
  label?: string;
  [key: string]: unknown;
};

type FilterByLike =
  | { id?: unknown; value?: unknown; label?: unknown }
  | null
  | undefined;

const hasId = (id: unknown) => id !== undefined && id !== null && id !== '';

export function findCustomFilter<T extends CustomFilterLike>(
  customFilters: T[] | null | undefined,
  filterConfig: object | null | undefined,
  filterBy: FilterByLike
): T | undefined {
  if (!filterBy) return undefined;
  if (hasId(filterBy.id)) {
    return customFilters?.find((filter) => filter?.id === filterBy.id);
  }
  const key = filterBy.value;
  if (
    typeof key === 'string' &&
    filterConfig &&
    (filterConfig as Record<string, unknown>)[key]
  )
    return undefined;
  // Legacy rows saved before custom fields carried an id.
  return customFilters?.find(
    (filter) =>
      filter?.label === filterBy.value ||
      filter?.label === filterBy.label ||
      filter?.id === filterBy.value ||
      filter?.id === filterBy.label
  );
}
